module.exports = __webpack_public_path__ + "static/webhook-url-ba3145a64dff56b31336032682e34114.png";